import { ApiResponse } from "@/domain";
import { backendApi } from "../backendApi";

interface JobStatusResponse {
  id: string;
  status: string;
  type: string;
  result?: any;
  progress?: {
    total: number;
    processed: number;
    pending: number;
  };
  error?: string;
  createdAt: string;
  updatedAt: string;
  completedAt?: Date;
}

export const jobApi = {
  getJobStatus: (jobId: string) =>
    backendApi.get<ApiResponse<JobStatusResponse>>(`/api/v1/jobs/${jobId}`).then((res) => res.data.data),

  startJob: (jobId: string) =>
    backendApi.post<ApiResponse<JobStatusResponse>>(`/api/v1/jobs/${jobId}/start`).then((res) => res.data.data),

  retryJob: (jobId: string) =>
    backendApi.post<ApiResponse<JobStatusResponse>>(`/api/v1/jobs/${jobId}/retry`).then((res) => res.data.data),
}